/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tags: NonNullable<unknown> }} Transcript_Export_Tags_LabelInputs */

const en_transcript_export_tags_label = /** @type {(inputs: Transcript_Export_Tags_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`TAGS: ${i?.tags}`)
};

const fr_transcript_export_tags_label = /** @type {(inputs: Transcript_Export_Tags_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`TAGS: ${i?.tags}`)
};

const de_transcript_export_tags_label = /** @type {(inputs: Transcript_Export_Tags_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`TAGS: ${i?.tags}`)
};

const it_transcript_export_tags_label = /** @type {(inputs: Transcript_Export_Tags_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`TAG: ${i?.tags}`)
};

const ru_transcript_export_tags_label = /** @type {(inputs: Transcript_Export_Tags_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ТЕГИ: ${i?.tags}`)
};

const es_transcript_export_tags_label = /** @type {(inputs: Transcript_Export_Tags_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ETIQUETAS: ${i?.tags}`)
};

const zh_cn2_transcript_export_tags_label = /** @type {(inputs: Transcript_Export_Tags_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`标签：${i?.tags}`)
};

const ja_transcript_export_tags_label = /** @type {(inputs: Transcript_Export_Tags_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`タグ: ${i?.tags}`)
};

const hi_transcript_export_tags_label = /** @type {(inputs: Transcript_Export_Tags_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`टैग: ${i?.tags}`)
};

const pt_pt2_transcript_export_tags_label = /** @type {(inputs: Transcript_Export_Tags_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`TAGS: ${i?.tags}`)
};

/**
* | output |
* | --- |
* | "TAGS: {tags}" |
*
* @param {Transcript_Export_Tags_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_tags_label = /** @type {((inputs: Transcript_Export_Tags_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Tags_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_transcript_export_tags_label(inputs)
	if (locale === "de") return de_transcript_export_tags_label(inputs)
	if (locale === "it") return it_transcript_export_tags_label(inputs)
	if (locale === "ru") return ru_transcript_export_tags_label(inputs)
	if (locale === "es") return es_transcript_export_tags_label(inputs)
	if (locale === "zh-CN") return zh_cn2_transcript_export_tags_label(inputs)
	if (locale === "ja") return ja_transcript_export_tags_label(inputs)
	if (locale === "hi") return hi_transcript_export_tags_label(inputs)
	if (locale === "pt-PT") return pt_pt2_transcript_export_tags_label(inputs)
	return en_transcript_export_tags_label(inputs)
});